
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/surf-reports-forecasts-cams-map/wind-stations",
      function () {
        return require("private-next-pages/surf-reports-forecasts-cams-map/wind-stations/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/surf-reports-forecasts-cams-map/wind-stations"])
      });
    }
  